import { useMemo } from 'react'

import { useAuth as useClerkAuth } from '@clerk/clerk-react'
import { GetAppStateQuery, GetAppStateQueryVariables } from 'types/graphql'

import { QueryKey, useQuery } from 'src/utils/queryClient'

const GetAppState = gql`
  query GetAppStateQuery {
    user: me {
      ...UserDataFragmentWithCompany
      recordTypeAccesses {
        id
        recordType {
          ...RecordTypeFragment
        }
      }
    }
    organization: myOrganization {
      ...OrganizationFragmentWithUsers
      aiChatLauncherBottomSpacingPx
      aiChatLauncherPosition
      aiChatLauncherSideSpacingPx
      aiChatLauncherUrlAllowList
      aiChatLauncherPopupEnabled
      aiChatLauncherPopupTitle
      aiChatLauncherPopupDescription
      aiChatScriptUrl
      aiCommunityAssistantMonthlyQuota
      allowNegativeFees
      hasRecordTypeWithApplicationAutoCheckEnabled
      hasRecordTypeWithMeetingsEnabled
      isPropertyOwnerAddressAvailable
      paymentProviderFormatted
      reportTemplateDocumentOptions {
        documentOptions {
          displayName
          documentType
          includeByDefault
        }
        reportTemplateType
      }
      finixMerchants {
        id
      }
      entityLayers {
        ...EntityLayerFragment
      }
    }
  }
`

export const useAppStateQuery = () => {
  const { userId, isLoaded } = useClerkAuth()
  const queryResult = useQuery<GetAppStateQuery, GetAppStateQueryVariables>({
    queryKey: [QueryKey.AppState, userId],
    queryDocument: GetAppState,
    variables: {},
    enabled: !!userId,
  })
  const data = useMemo(
    () => ({
      organization: queryResult.data?.organization,
      user: queryResult.data?.user,
    }),
    [queryResult.data]
  )

  const isLoading = !isLoaded || queryResult.isLoading
  return {
    ...queryResult,
    data,
    isLoading,
  }
}
